import type { SavedPersona } from '@/features/veluvit/types/api.types'

/** 대화에서 부를 이름 — 서버 player_address.py 와 같은 기준. 계정 닉네임은 쓰지 않고, 기본 페르소나가 없으면 '당신' */
export function playerName(personas?: SavedPersona[]): string {
  return personas?.find((persona) => persona.isDefault)?.name?.trim() || '당신'
}
